import { CommonModule } from '@angular/common';
import { Component, HostListener, OnInit } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { PoModule } from '@po-ui/ng-components';
import { TokenDataService } from '../../services/token.data.service';
import { StorageMenuAcess } from '../../models/storageMenuAcess.model';

@Component({
  standalone: true,
  imports: [PoModule, RouterOutlet, CommonModule],
  selector: 'last-menu-acess',
  templateUrl: './last-menu-acess.component.html',
  styleUrls: ['./last-menu-acess.component.css']
})
export class LastMenuAcessComponent implements OnInit{
  private userKey: string = this.generateUserKeyLocals();
  public menuItens: StorageMenuAcess[] = [];
  public screenWidth!: number;
  
  constructor(
       private tokenDataService: TokenDataService,
       private router: Router
  )
  {}

  ngOnInit() {
      this.getMenuMoreAcess();
      this.screenWidth = window.innerWidth;
  };

  @HostListener('window:resize', ['$event'])
  onResize(event : UIEvent) {
      this.screenWidth = window.innerWidth;
  }

  isSmallScreen(): boolean {
      return this.screenWidth <= 480;
  }

  isMediumScreen(): boolean {
      return this.screenWidth > 480 && this.screenWidth <= 960;
  }

  private getMenuMoreAcess(){
      const menuAcess = localStorage.getItem(this.userKey);
      if(menuAcess){
          this.menuItens = JSON.parse(menuAcess).storageMenuAcess;

          this.menuItens.sort((a, b) => b.countAcess - a.countAcess);
      }
  } 

  private generateUserKeyLocals(): string {
      const keyUserLocals =
      this.tokenDataService.userCode +
      ':' +
      this.tokenDataService.tenant;

      return btoa(keyUserLocals);
  }

  public navigateToPage(link: string): void{
      this.router.navigate(['/' + link]);
  }
}